import { Controller } from '@hotwired/stimulus'
import { armRow } from '../lib/armed_room_picker_rows'

export default class extends Controller {
  static values = { row: String }

  arm () {
    armRow(this.element.closest('form')?.getAttribute('action'), this.rowValue)
  }
}
